import { FormEvent, useState } from "react"
import { ANOTHER_SITE, COMPETITOR_QUESTION, REASON_CHOICES, REASON_QUESTION, SOMETHING_ELSE } from "./planDismissSurvey"
import "./PlanDismissSurvey.css"

interface PlanDismissSurveyProps {
    onAnswer: (reason: string, detail: string | null) => void
    onSkip: () => void
}

const NEEDS_TEXT = [ANOTHER_SITE, SOMETHING_ELSE]

export default function PlanDismissSurvey({ onAnswer, onSkip }: PlanDismissSurveyProps) {
    const [chosen, setChosen] = useState<string | null>(null)
    const [text, setText] = useState("")

    const choose = (choice: string) => {
        if (NEEDS_TEXT.includes(choice)) {
            setChosen(choice)
            return
        }
        onAnswer(choice, null)
    }

    const send = (event: FormEvent) => {
        event.preventDefault()
        const typed = text.trim()
        if (chosen) onAnswer(chosen, typed || null)
    }

    return (
        <section className="plan-dismiss-survey" aria-labelledby="plan-dismiss-survey-title">
            <h2 id="plan-dismiss-survey-title" className="plan-dismiss-survey-title">{REASON_QUESTION}</h2>
            <p className="plan-dismiss-survey-subtitle">One tap helps us make HomeIndex better.</p>
            {chosen ? (
                <form className="plan-dismiss-survey-form" onSubmit={send}>
                    <label className="plan-dismiss-survey-label" htmlFor="plan-dismiss-survey-text">
                        {chosen === ANOTHER_SITE ? COMPETITOR_QUESTION : "What was it?"}
                        <span> (optional)</span>
                    </label>
                    <input
                        id="plan-dismiss-survey-text"
                        className="plan-dismiss-survey-input"
                        value={text}
                        maxLength={200}
                        autoFocus
                        onChange={event => setText(event.target.value)}
                    />
                    <button type="submit" className="plan-dismiss-survey-send">Send</button>
                </form>
            ) : (
                <div className="plan-dismiss-survey-choices">
                    {REASON_CHOICES.map(choice => (
                        <button key={choice} type="button" className="plan-dismiss-survey-choice" onClick={() => choose(choice)}>
                            {choice}
                        </button>
                    ))}
                </div>
            )}
            <button type="button" className="plan-dismiss-survey-skip" onClick={onSkip}>No thanks</button>
        </section>
    )
}
